export default "__VITE_ASSET__9O0QBkts__"